<template>
  <layout>
    <div class="flex flex-col items-center">
      <div class="w-full lg:w-2/3 bg-white rounded flex flex-col border mb-8">
        <div class="w-full flex flex-1 p-4">
          <div class="w-3/4 flex flex-col">
            <div class="font-bold mb-2">{{ branch.restaurant_name }}</div>
            <div class="text-sm text-grey-dark">{{ branch.restaurant_address }}</div>
          </div>
          <div class="w-1/4 flex items-center justify-end">
            <div class="mr-2">Receiving Orders</div>
            <div
              v-if="branch.accepting_order"
              class="w-auto inline-block px-4 py-1 rounded-full uppercase text-primary-dark bg-primary-lighter"
            >Yes</div>
            <div
              v-else
              class="w-auto inline-block px-4 py-1 rounded-full uppercase text-red bg-red-light"
            >No</div>

          </div>
        </div>
        <date-range-selector
          @date-selected="getTotalEarnings"
        />
        <div class="w-full flex p-4 sm:flex-col lg:flex-row">
          <div class="sm:w-full lg:w-1/2 flex flex-col items-center justify-center sm:mr-0 lg:mr-2 sm:mb-4 lg:mb-0 border rounded py-4">
            <div class="mb-2 font-bold">Total Orders</div>
            <div class="text-xl font-bold">{{ earnings.total_orders }}</div>
          </div>
          <div class="sm:w-full lg:w-1/2 flex flex-col items-center justify-center sm:ml-0 lg:ml-2 border rounded py-4">
            <div class="mb-2 font-bold">Total Earnings</div>
            <div class="text-xl font-bold">{{ earnings.total_earnings }}</div>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-2/3 bg-white rounded flex border p-4 flex sm:flex-col lg:flex-row">
        <div class="flex flex-col sm:w-full lg:w-1/2 sm:mb-4 lg:mb-0 sm:mr-0 lg:mr-2">
          <div class="font-bold text-lg mb-4">Available Items</div>
          <pt-view-table
            :data="availableItems"
            :columns="tableColumns"
            :row-class="classes.row"
            :header-class="classes.header"
            :column-class="classes.column"
            :tbody-class="classes.tbody"
            :thead-class="classes.thead"
            class="promo-table border rounded mb-8"
          />
        </div>
        <div class="flex flex-col sm:w-full lg:w-1/2 sm:mb-4 lg:mb-0 sm:ml-0 lg:ml-2">
          <div class="font-bold text-lg mb-4">Popular Items</div>
          <pt-view-table
            :data="popularItems"
            :columns="tableColumns"
            :row-class="classes.row"
            :header-class="classes.header"
            :column-class="classes.column"
            :tbody-class="classes.tbody"
            :thead-class="classes.thead"
            class="promo-table border rounded mb-8"
          />
        </div>
        <div class="flex">
          <!--<pt-view-table
            :data="branches"
            :columns="columns"
            :row-class="classes.row"
            :header-class="classes.header"
            :column-class="classes.column"
            :tbody-class="classes.tbody"
            :thead-class="classes.thead"
            class="promo-table shadow border-t"
          />-->
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { PtFormInput } from '@pathao/ui-components/esm/FormComponents';
import { PtViewTable } from '@pathao/ui-components/esm/Table';
import { PtPopover } from '@pathao/ui-components/esm/Popover';
import Layout from '@layouts/resto-admin';
import { RESTO_ADMIN_BRANCH_DETAIL, RESTO_ADMIN_BRANCH_EARNINGS, RESTO_ADMIN_BRANCH_AVAILABLE_ITEMS, RESTO_ADMIN_BRANCH_POPULAR_ITEMS } from '@src/config/apiEndpoints';
import apiRequest from '@src/utils/apiRequest';
import DateRangeSelector from '@src/components/custom/DateRangeSelector';

export default {
  name: 'Branch',
  page: {
    title: 'Branch',
  },
  components: { PtFormInput, PtViewTable, PtPopover, DateRangeSelector, Layout },
  data() {
    return {
      branch: {},
      earnings: {},
      availableItems: [],
      popularItems: [],
      classes: {
        thead: 'bg-grey-lighter w-full',
        tbody: 'bg-white text-center',
        row: 'border-b-4 lg:border-b border-solid border-grey-light mb-0 w-full',
        column: 'p-4 border-b lg:border-b-0',
        header: 'py-4',
      },
      tableColumns: [{
        header: 'Name & Description',
        class: 'font-bold text-left pl-4',
        component: {
          props: ['rowData'],
          render() {
            return (
              <div class="flex">
                <div class="w-8">{ this.rowData.index }.</div>
                <div class="flex-1 flex-col">
                  <div class="font-bold">{ this.rowData.name }</div>
                  <div class="text-grey">{ this.rowData.category ? this.rowData.category.name : '' }</div>
                </div>
              </div>
            );
          },
        },
      }, {
        header: 'Price',
        accessor: 'price',
        class: 'text-right pr-4',
      }],
    };
  },
  mounted() {
    this.getBranchDetail();
    this.getAvailableItems();
    this.getPopularItems();
  },
  methods: {
    getBranchDetail() {
      const url = RESTO_ADMIN_BRANCH_DETAIL.replace(':id', this.$route.params.id);
      apiRequest({ url })
        .then((response) => {
          this.branch = response.data.restaurant_information;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getTotalEarnings(dateRange = {}) {
      const url = RESTO_ADMIN_BRANCH_EARNINGS.replace(':id', this.$route.params.id);
      const params = {
        ...dateRange,
      };

      apiRequest({
        url,
        params,
      })
        .then((response) => {
          this.earnings = response.data.earnings;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getPopularItems() {
      const url = RESTO_ADMIN_BRANCH_POPULAR_ITEMS.replace(':id', this.$route.params.id);
      apiRequest({ url })
        .then((response) => {
          let itemIndex = 1;
          const transformed = [];

          response.data.popular_items.forEach(itemType => {
            transformed.push({
              index: itemIndex++,
              ...itemType.item_details,
            });
          });

          this.popularItems = transformed;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getAvailableItems() {
      const url = RESTO_ADMIN_BRANCH_AVAILABLE_ITEMS.replace(':id', this.$route.params.id);
      apiRequest({ url })
        .then((response) => {
          let itemIndex = 1;
          const transformed = [];

          response.data.menus.forEach(itemType => {
            itemType.items.forEach(item => {
              transformed.push({
                index: itemIndex++,
                ...item,
              });
            });
          });

          this.availableItems = transformed;
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>
